import {JSX} from "react";
import {formatCurrency} from "../functions";
import {usePermits} from "../hooks/usePermits";
import {useUser} from "../hooks/useUser";

export default function TopUserInfo(): JSX.Element | undefined {
	const user = useUser();
	const {permits} = usePermits();

	return <div className="top-user-info">
		<span className="top-user-info__user">Welcome back, {user.email}</span>
		{permits.userState.balance > 0 && <span className="top-user-info__wallet">You have {formatCurrency(permits.userState.balance)} in your wallet</span>}
	</div>;
}
